import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandJourneys(props: IconProps) {
  return (
    <BaseIcon size={40} viewBox="0 0 40 40" {...props}>
      <g clipPath="url(#clip0_23430_865)">
        <path
          d="M27.5 8.75C27.5 6.67893 29.1789 5 31.25 5C33.3211 5 35 6.67893 35 8.75V20C35 22.0711 33.3211 23.75 31.25 23.75C29.1789 23.75 27.5 22.0711 27.5 20V8.75Z"
          fill="#3C3C64"
        />
        <path
          d="M5 20C5 17.9289 6.67893 16.25 8.75 16.25C10.8211 16.25 12.5 17.9289 12.5 20V31.25C12.5 33.3211 10.8211 35 8.75 35C6.67893 35 5 33.3211 5 31.25V20Z"
          fill="#3C3C64"
        />
        <path
          d="M20 5C22.0711 5 23.75 6.67893 23.75 8.75C23.75 10.8211 22.0711 12.5 20 12.5L8.75 12.5C6.67893 12.5 5 10.8211 5 8.75C5 6.67893 6.67893 5 8.75 5L20 5Z"
          fill="#3C3C64"
        />
        <path
          d="M31.25 27.5C33.3211 27.5 35 29.1789 35 31.25C35 33.3211 33.3211 35 31.25 35L20 35C17.9289 35 16.25 33.3211 16.25 31.25C16.25 29.1789 17.9289 27.5 20 27.5L31.25 27.5Z"
          fill="#3C3C64"
        />
      </g>
      <defs>
        <clipPath id="clip0_23430_865">
          <rect width="30" height="30" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
}
